<!-- Copyright 2022, Common Good Learning Tools LLC -->
<template>
<HighDemandCareerPathwaysToolInner/>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import HighDemandCareerPathwaysToolInner from './HighDemandCareerPathwaysToolInner'

export default {
	components: { HighDemandCareerPathwaysToolInner },
	props: {
	},
	data() { return {
	}},
	computed: {
		...mapState([]),
		...mapGetters([]),
	},
	watch: {
	},
	created() {
	},
	mounted() {
	},
	methods: {
	}
}
</script>

<style lang="scss">
</style>